<template>
  <div class="edit-list-content">
    <input class="title-input" v-model="title" type="text" />

    <BotRiotLists :bot-riot-lists="botRiotLists" />
    <Alarms :alarms="alarms" />
    <input class="robot-url-input" v-model="robotUrl" type="text" placeholder="Робот Url" />
    <div class="buttons mt-1">
      <Button title="Сохранить" class="save green" @click="save()" icon="save" />
      <Button title="Отменить" class="cancel red" @click="cancel()" icon="times" />
      <Button
        :title="archived ? 'Из архива' : 'В архив'"
        class="archive gray"
        @click="archive()"
        icon="archive"
      />
    </div>
    <div class="empty" />
  </div>
</template>
<script>
import Alarms from "./../alarms/Alarms.vue";
import BotRiotLists from "./BotRiotLists.vue";

export default {
  name: "EditListContent",
  components: { Alarms, BotRiotLists },
  props: ["list"],
  computed: {
    archived() {
      if (!this.list) {
        return false;
      }

      return this.list.archived;
    },
  },
  data() {
    return {
      title: "",
      robotUrl: null,
      botRiotLists: [],
      fields: [],
      alarms: [],
    };
  },
  created() {
    this.$eventHub.$on("command-save", this.save);
    this.$eventHub.$on("command-cancel", this.cancel);
  },
  beforeDestroy() {
    this.$eventHub.$off("command-save");
    this.$eventHub.$off("command-cancel");
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (this.title && this.list.title != this.title) {
        this.$store.dispatch("lists/editTitle", {
          list: this.list,
          title: this.title,
        });
      }
      if (this.list.robot_url != this.robotUrl) {
        this.$store.dispatch("lists/editRobotUrl", {
          list: this.list,
          robot_url: this.robotUrl,
        });
      }
      if (this.botRiotListRiotRoomId) {
        this.botRiotListRiotRoomId = this.botRiotListRiotRoomId.trim();
      } else {
        this.botRiotListRiotRoomId = "";
      }

      this.botRiotLists.forEach((botRiotList) => {
        if (!botRiotList.id) {
          this.$store.dispatch("botRiotLists/new", {
            list: this.list,
            botRiotList: botRiotList,
          });
          return;
        }

        const existing = this.list.botRiotLists.find((a) => a.id == botRiotList.id);
        if (!existing) {
          return;
        }

        this.$store.dispatch("botRiotLists/update", {
          list: this.list,
          newBotRiotList: botRiotList,
          oldBotRiotList: existing,
        });
      });

      this.alarms.forEach((alarm) => {
        if (!alarm.id) {
          this.$store.dispatch("alarms/new", {
            list: this.list,
            alarm: alarm,
          });
          return;
        }

        const existing = this.list.alarms.find((a) => a.id == alarm.id);
        if (!existing) {
          return;
        }

        this.$store.dispatch("alarms/update", {
          list: this.list,
          newAlarm: alarm,
          oldAlarm: existing,
        });
      });

      this.cancel();
    },
    archive() {
      const _this = this;
      if (this.list.archived) {
        this.$modal.show("ConfirmationDialog", {
          message: "Точно убрать лист <b>из архива</b>?",
          yes: () => {
            this.$store.dispatch("lists/dearchive", this.list);
            _this.cancel();
          },
        });
      } else {
        this.$modal.show("ConfirmationDialog", {
          message: "Точно переместить лист в <b>Архив</b>?<br>Его не будет после этого на Доске.",
          yes: () => {
            this.$store.dispatch("lists/archive", this.list);
            _this.cancel();
          },
        });
      }
    },
  },
  mounted() {},
  watch: {
    list: {
      immediate: true,
      handler: function (newList) {
        if (!newList) return;

        this.title = newList.title;
        this.robotUrl = newList.robot_url;
        this.botRiotLists = newList.botRiotLists.map((a) => Object.assign({}, a));
        this.alarms = newList.alarms.map((a) => Object.assign({}, a));
      },
    },
  },
};
</script>
<style lang="postcss">
.edit-list-content {
  display: grid;
  grid-gap: 0.2em;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto auto 1fr;
  grid-template-areas:
    "title"
    "list-fields"
    "alarms"
    "robot-url"
    "buttons"
    "empty";

  height: 100%;

  .title-input {
    padding: 5px;
    height: 1.5em;
    font-size: 20px !important;
    font-weight: 700;
  }

  .title-input {
    grid-area: title;
  }

  .robot-url-input {
    grid-area: robot-url;
  }

  .fields-container {
    display: grid;
    grid-gap: 0.2em;
    grid-template-columns: auto 2fr;
    grid-template-rows: 2em;
    grid-template-areas: "title value";
    margin: 0.5em 0;

    .field-title {
      grid-area: title;
      align-self: center;
    }

    .field-value {
      grid-area: value;
    }
  }

  .alarms-container {
    grid-area: alarms;
  }

  .buttons {
    grid-area: buttons;
    display: grid;
    grid-gap: 0.2em;
    grid-template-rows: 1fr;
    grid-template-columns: 10fr 10fr 10fr;
    margin-bottom: 0.5em;
  }

  .empty {
    grid-area: empty;
  }
}
</style>


